import { Injectable } from "@angular/core";
import { BaseService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-service.component";
import { AuthService } from "projects/sepidz-web-framework/src/lib/services";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { SaleMethodNature } from "src/app/frontoffice/sales/model/sale-method-branch.model";
import { ActivePageEnum } from "../../model/activepage.enum";
import { FastAccessEnum } from "../../model/fastaccessenum";
import { InvoiceStatus } from "../../model/invoice.model";
import { OrderService } from "../../order.service";
import { ProtelModel } from "projects/sepidz-web-framework/src/lib/models/Protel.model";
import { take } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class FastAccessService extends BaseService {
  //   currentSaleMethodBranch: SaleMethodBranchModel;1
  saleMethodNature: typeof SaleMethodNature = SaleMethodNature;
  descriptionExpantion: boolean = false;
  public fastAccessEnum: typeof FastAccessEnum = FastAccessEnum;
  public activePageEnum: typeof ActivePageEnum = ActivePageEnum;
  public invoicestatus: typeof InvoiceStatus = InvoiceStatus;
  hasClub: boolean;
  hasLinkPayment: boolean;
  protel: ProtelModel;

  constructor(public order: OrderService, public authService: AuthService, public common: CommonService) {
    super();
    this.hasClub = this.authService?.currentInformation().HasClub;
    this.hasLinkPayment = this.authService?.currentInformation().PaymentPanelAVA;
  }

  public _toggleOpened(fastAccessName: FastAccessEnum) {
    if (this.order._opened && fastAccessName && this.order.selectedFastAccess != fastAccessName) this.order._opened = true;
    else this.order._opened = !this.order._opened;

    this.order.selectedFastAccess = fastAccessName;
    setTimeout(() => {
      this.order.cd.markForCheck();
    }, 1000);
  }

  closeSidebar(clickEvent: any) {
    if (clickEvent["closest"](".mobile-fast-access")) return;

    if (this.common.isMobileMode && this.order.hideFastAccess) this.order.hideFastAccess = false;

    if (this.order._opened) {
      if (this.order.shouldCloseSidebar) this.order._opened = false;
      else this.order.shouldCloseSidebar = true;
    }
  }
  GetProtelInfo() {
    const roomNumber = this.order.invoice.Customer.Party.LastName;
    if (this.order.invoice.AutomaticDebtor || this.order.invoice.isDebit) {
      this.httpCommonService
        .get(`Invoice/GetProtelData/${roomNumber}`)
        .pipe(take(1))
        .subscribe(
          (data: ProtelModel[]) => {
            this.protel = data[0];
            if (this.protel == null) {
              this.sts.showDialog(
                this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.InformationToDisplay"),
                this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Attention")
              );
            } else {
              const name = this.protel.FullName;
              let reservationNumber = this.protel.ReservationNumber;
              const rmNumber = this.protel.RoomNumber;
              this.sts.showDialog(
                `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Name")}: ${name}
                                  ${this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.RoomNumber")}: ${rmNumber}
                                  ${this.translate(
                                    "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.ReservationNumber"
                                  )}: ${reservationNumber}`,
                this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Attention")
              );
            }
          },
          (err) => {
            this.sts.showDialog(
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.CommunicationWithProtelEstablished"),
              this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Attention")
            );
          }
        );
    } else {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.DesiredSubscriberIsNotValid"),
        this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.Fastacces.Attention")
      );
    }
  }
}
